import { QUERY_KEYS } from '../../../../consts';
import { getInvoicesService } from '../../../../services';
import { getAtomWithMutation } from '../../../../utils';

export const getInvoicesAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.PATIENTS.INVOICES,
  mutationFn: () => getInvoicesService,
});
